export const CLUB_IDS = {
  mongolUndesniiKharwaaKholboo: "mongolUndesniiKharwaaKholboo",
  mongoliinMusunSuriinKholboo: "mongoliinMusunSuriinKholboo",
  mongoliinUwugUriankhaiSuriinKholboo: "mongoliinUwugUriankhaiSuriinKholboo",
  buriadSuriinKholboo: "buriadSuriinKholboo"
} as const;

export const CURRENT_CLUB_ID = CLUB_IDS.mongolUndesniiKharwaaKholboo;
